import type {
  IEventData,
  IMustPayload,
  IAscEventPayload,
} from '@/utils/tracking/types'
import { config } from '@/config/generated-config'

export const sendTrackingEvent = (
  accountId: string,
  entityId: string,
  eventData: IEventData,
) => {
  const vehicleData = eventData?.vehicle
  const payload: IMustPayload = {
    account: accountId,
    entityId,
    sessionId: eventData.sessionId,
    deviceFingerprint: eventData.deviceFingerprint,
    eventType: eventData.eventType,
    placement: eventData.placement,
    source: 'micro_srp',
    path: window.location.href,
  }

  if (vehicleData) {
    payload.make = vehicleData.make ?? ''
    payload.model = vehicleData.model ?? ''
    payload.stockNumber = vehicleData.stockNumber ?? ''
    payload.vin = vehicleData.vin ?? ''
    payload.year = Number(vehicleData.year ?? 0)
  }

  try {
    const endpoint = config.VITE_MUST_ENDPOINT
    const url = new URL(`${endpoint}/track`)
    url.searchParams.set('product', 'micro_srp')
    url.searchParams.set('accountId', String(accountId ?? '').trim())
    url.searchParams.set('juid', String(accountId ?? '').trim())

    fetch(url.toString(), {
      method: 'POST',
      body: JSON.stringify([payload]),
    }).catch(error => {
      console.error('Network request failed:', error)
    })
  } catch (error) {
    console.error('Failed to send tracking event:', error)
  }
}

export const sendAscEvent = (ascPayload: IAscEventPayload): void => {
  try {
    // 1) Push to dataLayer for universal pickup (GTM/GA4/Adobe, etc.)
    const w = window as any
    w.dataLayer = w.dataLayer || []
    const { event_name, ...params } = ascPayload
    w.dataLayer.push({
      event: event_name,
      ...params,
    })

    // 2) Optional HTTP sink for ASC payloads (middleware/CDP)
    const endpoint = config.VITE_ASC_ENDPOINT
    if (!endpoint) {
      return
    }
    const url = `${endpoint}/track`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(ascPayload),
    }).catch(error => {
      console.error('ASC network request failed:', error)
    })
  } catch (error) {
    console.error('Failed to send ASC event:', error)
  }
}
